import { useState } from "react";
import { supabase } from "../lib/supabase";

export type RegistrationStatus = "idle" | "submitting" | "success" | "duplicate" | "error";

interface RegistrationFields {
  source_page: string;
  interested_service?: string;
}

/** Shared insert logic for the `interest_registrations` table (email lead capture). */
export function useInterestRegistration() {
  const [status, setStatus] = useState<RegistrationStatus>("idle");

  const register = async (email: string, fields: RegistrationFields): Promise<RegistrationStatus> => {
    setStatus("submitting");

    let result: RegistrationStatus;
    try {
      const { error } = await supabase.from("interest_registrations").insert({
        email: email.trim().toLowerCase(),
        ...fields,
      });
      result = !error ? "success" : error.code === "23505" ? "duplicate" : "error";
    } catch {
      result = "error";
    }

    setStatus(result);
    return result;
  };

  const reset = () => setStatus("idle");

  return { status, register, reset };
}
